import {Injectable} from '@angular/core';
import {FormPage} from '../models/WebFormTemplate';
import {AbstractControl, UntypedFormArray, UntypedFormGroup} from '@angular/forms';
import {CustomFormControl} from '../components/controls/CustomFormControl';

@Injectable({
  providedIn: 'root'
})
export class FormHelperService {

  isMobileDevice(): boolean {
    const userAgent = window.navigator.userAgent;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegex.test(userAgent);
  }

  isSafari(): boolean {
    const userAgent = navigator.userAgent;
    return /^((?!chrome|android).)*safari/i.test(userAgent);
  }

  openLinkInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  openLinkInTab(url: string): void {
    window.location.href = url;
  }

  markFormAsTouched(formGroup: UntypedFormGroup): void {
    Object.values(formGroup.controls).forEach((control) => {
      if (control instanceof UntypedFormArray) {
        for (let i = 0; i < control.length; ++i) {
          const arrayControl = control.at(i);
          if (arrayControl instanceof UntypedFormGroup) {
            this.markFormAsTouched(arrayControl);
          } else {
            arrayControl.markAsTouched({ onlySelf: true });
          }
        }
      } else if (control instanceof UntypedFormGroup) {
        this.markFormAsTouched(control);
      } else {
        control.markAsTouched({ onlySelf: true });
      }
    });
  }

  isFormPageVisible(formPage: FormPage, controls: Map<string, CustomFormControl>): boolean {
    if (!formPage.visibility) { return true; } // Not enforcing conditional rendering

    const customControl = controls.get(formPage.visibility.targetControl);
    if (!customControl) {
      console.error('Conditional rendering was enabled, but the control ID does not exist.');
      return true;
    }

    return customControl.element.option === formPage.visibility.targetValue;
  }

  getFormArrayName(id: string): string {
    return id + '_array';
  }

  getValidIndicator(control: AbstractControl | CustomFormControl): string {
    if (control instanceof CustomFormControl && (control.element.readOnly || control.disabled)) {
      return 'form-control';
    }

    if (control.touched && !control.valid) { return 'form-control is-invalid'; }
    if (control.touched && control.valid) { return 'form-control is-valid'; }
    return 'form-control';
  }
}
